import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FeedbackService } from '../../../services/feedback.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

export interface FeedbackData {
    id: string;
    fedId: string;
    topic: string;
    subTopic: string;
    subject: string;
    name: string;
    date: string;
    contactLogo: string
}

@Component({
    selector: 'app-feedback-dashboard',
    templateUrl: './feedback-dashboard.component.html',
    styleUrls: ['./feedback-dashboard.component.scss']
})
export class FeedbackDashboardComponent implements AfterViewInit {

    displayedColumns: string[] = ['fedId', 'topic', 'subTopic', 'subject', 'name', 'date'];
    dataSource: MatTableDataSource<FeedbackData>;

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;

    feedbacks: Array<FeedbackData> = [];
    loadingMessage: string = "Loading...";

    pagecode: string = "feedback-dashboard";
    module: string = "feedback";
    accessdenied: boolean = false;

    constructor(private route: ActivatedRoute, private _router: Router, private feedbackService: FeedbackService, private authentication: AuthenticationService, private common: CommonService) {

        this.dataSource = new MatTableDataSource(this.feedbacks);

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {


                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        this.getUserFeedbacks();
                        //
                        window.scroll(0, 0);


                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });

    }
    getUserFeedbacks() {
        this.feedbackService.getUserFeedback(this.authentication._authentication.id).subscribe(
            (res: any) => {

                for (var i = 0; i < res.length; i++) {
                    this.feedbacks.push({
                        id: res[i].id,
                        fedId: res[i].id,
                        topic: res[i].topic,
                        subTopic: res[i].subTopic,
                        subject: res[i].subject,
                        name: res[i].owner.firstName + ' ' + res[i].owner.lastName,
                        date: res[i].createdDate,
                        contactLogo: res[i].owner.contactLogo
                    });
                }
                this.dataSource = new MatTableDataSource(this.feedbacks);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.loadingMessage = "No data found";
            },
            (err: any) => { }
        );
    }

    clickedRows(row: any) {
        this._router.navigate(['/feedback/detail/' + row.id]);
    }
    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
}

